import { useState } from 'react';

import PropTypes from 'prop-types';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import Info from '../Info';

const PasswordFieldComponent = (props) => {
  const { t } = useTransl();
  const {
    input: { onChange, ...inputProps },
    meta: { touched, error, active },
    showPasswordRequirements,
    ...custom
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const onPasswordChange = (e) => onChange(e.target.value.trim());

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const hasError = touched && !!error;
  const customProps = { fullWidth: true, ...custom };

  const passwordRequirements = t('errors.password');

  return (
    <FormControl
      variant="outlined"
      size="small"
      error={hasError}
      {...customProps}
    >
      {showPasswordRequirements && active && (
        <Info>{passwordRequirements}</Info>
      )}
      <OutlinedInput
        type={showPassword ? 'text' : 'password'}
        error={hasError}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={t('ariaLabel.password')}
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              size="large"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
        onChange={onPasswordChange}
        {...inputProps}
        {...customProps}
      />
      {hasError && <FormHelperText component="div">{error}</FormHelperText>}
    </FormControl>
  );
};
PasswordFieldComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  showPasswordRequirements: PropTypes.bool,
};

export default PasswordFieldComponent;
